import Swiper from "swiper";
import { find } from "utils/dom";

export default function () {
    const Home = find("[js-page='home']");
    if (!Home) return;

    const swiperHero = new Swiper(".swiper-hero", {
        effect: "fade",
        loop: true,
        fadeEffect: { crossFade: true },
        autoplay: { delay: 5000, disableOnInteraction: false },
				speed: 800,
    });

    const swiperSections = new Swiper(".swiper-sections", {
        slidesPerView: 1,
        effect: "creative",
        allowTouchMove: false,
        creativeEffect: {
            prev: { translate: [0, "-20%", -1] },
            next: { translate: [0, "100%", 0] },
        },
        on: {
            slideChange: () => {
                const viewport = document.getElementById("view-port");
                if (!viewport) return;

                if (swiperSections.activeIndex === 4) {
									if (window.innerWidth < 600) {
										viewport.style.marginTop = "22vh";
									} else {
										viewport.style.marginTop = "46vh";
									}
                } else {
									if (window.innerWidth < 600) {
										viewport.style.marginTop = "57px";
									} else {
										viewport.style.marginTop = "80px";
									}
                }
            },
        },
    });

    const initializeBottomBar = () => {
        const bottomBarDesktop = document.querySelector(".bottom-bar-desktop");
        const links = document.querySelectorAll("#bottom-bar .link");

        bottomBarDesktop.style.borderTop = "1px solid transparent";
        bottomBarDesktop.style.transition = "border-top 0.5s ease";
        links.forEach(link => {
            link.style.color = "#F4F1E6";
            link.style.transition = "color 0.5s ease, text-decoration 0.3s ease";
        });
    };

    const closeEquipeSection = () => {
        const allSections = document.querySelectorAll(".interna-equipe.active");

        allSections.forEach(section => {
            section.classList.remove("active");

            setTimeout(() => {
                section.style.visibility = "hidden";
                section.style.transform = "translateX(-100%)";
            }, 500);
        });
    };

    const handleEquipeItemClick = () => {
			const equipeItems = document.querySelectorAll(".equipe-item");
	
			equipeItems.forEach(item => {
					item.addEventListener("click", () => {
							const memberId = item.getAttribute("data-member");
							const targetSection = document.getElementById(memberId);
	
							if (!targetSection) return;
	
							closeEquipeSection();
	
							setTimeout(() => {
									targetSection.style.visibility = "visible";
									targetSection.style.transform = "translateX(0)";
									targetSection.classList.add("active");
							}, 100); 
	
							const undoWrappers = targetSection.querySelectorAll(".undo-wrapper");
							undoWrappers.forEach(undo => {
									undo.addEventListener("click", closeEquipeSection);
							});
					});
			});
		};

		const manageSectionToggle = (sectionKey, clickedLink) => {
			const viewport = document.getElementById("view-port");
			const isActive = viewport.classList.contains("active");
			const bottomBar = document.querySelector("#bottom-bar");
			const bottomBarDesktop = document.querySelector(".bottom-bar-desktop");
			const bottomBarMobile = document.querySelector(".bottom-bar-mobile");
			const links = document.querySelectorAll("#bottom-bar .link");
			const menuLabel = document.getElementById("menu-label");
			const menuToggle = document.getElementById("menu-toggle");
			const dropdownMenu = document.getElementById("dropdown-menu");
			const menuIcon = menuToggle.querySelector("svg");
	
			const addHoverEffect = event => {
					if (!event.target.classList.contains("active")) {
							event.target.style.textDecoration = "underline";
					}
			};
	
			const removeHoverEffect = event => {
					if (!event.target.classList.contains("active")) {
							event.target.style.textDecoration = "none";
					}
			};
	
			if (isActive && clickedLink.classList.contains("active")) {
					viewport.classList.remove("active");
					clickedLink.classList.remove("active");
					swiperSections.slideTo(0, 1000);
					history.pushState(null, "", window.location.pathname);
	
					bottomBar.classList.add("backdrop-blur-lg");
					bottomBar.style.backgroundColor = "transparent";
					bottomBarDesktop.style.borderTop = "1px solid transparent";
	
					setTimeout(() => {
							bottomBarDesktop.classList.add("bg-menu/30");
					}, 300);
	
					links.forEach(link => {
							link.style.color = "#F4F1E6";
							link.style.textDecoration = "none";
							link.classList.remove("active"); // Removendo classe active ao fechar
					});
	
					swiperHero.autoplay.start();
					swiperHero.slideTo(0);
			} else {
					closeEquipeSection();
	
					links.forEach(link => {
							link.style.color = "#34472C";
							link.style.textDecoration = "none";
							link.classList.remove("active");
					});
	
					clickedLink.classList.add("active");
					clickedLink.style.textDecoration = "underline";
					viewport.classList.add("active");
	
					const sectionIndex = Array.from(navLinks).findIndex(link => link.dataset.section === sectionKey);
					swiperSections.slideTo(sectionIndex, 1000);
	
					window.scrollTo({
							top: 0,
							behavior: "smooth",
					});
	
					bottomBar.classList.remove("backdrop-blur-lg");
					bottomBar.style.backgroundColor = "#EFEBDC";
					bottomBar.style.transition = "background-color 0.5s ease, backdrop-filter 0.5s ease";
					bottomBarDesktop.style.borderTop = "1px solid #D7C9B4";
					bottomBarMobile.style.borderTop = "1px solid #D7C9B4";
					menuToggle.style.backgroundColor = "#EFEBDC";
	
					bottomBarDesktop.classList.remove("bg-menu/30");
	
					const url = new URL(window.location);
					url.searchParams.set("key", sectionKey);
					history.pushState(null, "", url.toString());
	
					swiperHero.slideTo(2);
					swiperHero.autoplay.stop();
	
					if (dropdownMenu) {
							dropdownMenu.style.transform = "translateY(125%)";
					}
	
					if (menuLabel && clickedLink.dataset.section) {
							menuLabel.textContent = clickedLink.textContent.trim();
							menuLabel.style.textDecoration = "underline";
							menuLabel.classList.replace("text-background", "text-primary-pure");
							menuIcon.classList.replace("text-background", "text-primary-pure");
					}
			}
	
			// Garante hover sempre ativo e mantém o link ativo sublinhado
			links.forEach(link => {
					link.addEventListener("mouseover", addHoverEffect);
					link.addEventListener("mouseout", removeHoverEffect);
	
					// Mantém o sublinhado no link ativo
					if (link.classList.contains("active")) {
							link.style.textDecoration = "underline";
					}
			});
		};
	
		const navLinks = document.querySelectorAll("#bottom-bar .link");
		navLinks.forEach(link => {
				link.addEventListener("click", (e) => {
						e.preventDefault();
						const sectionKey = link.dataset.section;
						manageSectionToggle(sectionKey, link);
				});
		});
	
    const initializeDropdownMenu = () => {
        const menuToggle = document.getElementById("menu-toggle");
        const dropdownMenu = document.getElementById("dropdown-menu");

        dropdownMenu.style.transform = "translateY(125%)";
        dropdownMenu.style.transition = "transform 0.5s ease-in-out";

        const toggleDropdown = () => {
            const isVisible = dropdownMenu.style.transform === "translateY(0%)";

            if (isVisible) {
                dropdownMenu.style.transform = "translateY(125%)";
            } else {
                dropdownMenu.style.transform = "translateY(0%)";
            }
        };

        menuToggle.addEventListener("click", toggleDropdown);
    };

    window.addEventListener("DOMContentLoaded", () => {
			initializeBottomBar();
			handleEquipeItemClick();
			initializeDropdownMenu();
	
			const viewport = document.getElementById("view-port");
			if (viewport) {
					const existingTransition = getComputedStyle(viewport).transition;
					viewport.style.transition = `${existingTransition}, margin-top 0.5s ease`;
			}
	
			const urlParams = new URLSearchParams(window.location.search);
			const sectionKey = urlParams.get("key");
	
			if (sectionKey) {
					const initialLink = Array.from(navLinks).find(link => link.dataset.section === sectionKey);
					if (initialLink) {
							manageSectionToggle(sectionKey, initialLink);
					} else {
							console.warn(`No section found for key: ${sectionKey}`);
					}
			}
		});
}
